import { dateStrFormatRegex } from './regex';

// Validate that the input date is in between two specified boundary dates.
// If you only want to check against one boundary date, just specify undefined/null for the other one.
const dateInRange = (startDate, endDate) => valueStr => {
	if (!valueStr) {
		return undefined;
	}
	if (!valueStr.match(dateStrFormatRegex)) {
		return 'Invalid date format. Please use MM/DD/YYYY';
	}
	const valueArr = valueStr.split('-');
	// Subtract 1 from month because months in Date objects are 0-based
	const valueDate = new Date(valueArr[0], valueArr[1] - 1, valueArr[2]);
	// Without setFullYear, the Date constructor assumes any 2-digit years are in the 1900s.
	valueDate.setFullYear(valueArr[0]);
	if (startDate && valueDate < startDate) {
		return `Cannot be before ${startDate.toLocaleDateString()}`;
	}
	if (endDate && valueDate > endDate) {
		return `Cannot be after ${endDate.toLocaleDateString()}`;
	}
	return undefined;
};

export default dateInRange;
